declare const navigator: any;

export class AlertNotification  {
    private url: string;
    private errored: boolean = false;
    private defaultobject:any;
    private enabled:boolean = false;

    constructor(enabled:boolean,url: string,defaultobject:any) {
        this.url = url;
        this.defaultobject=defaultobject;
        this.enabled=enabled;
    }

    isEnabled() {
        return this.enabled;
    }

    notify(content: any): void {
        const { url } = this;
        let notifyvalue = {
                ...this.defaultobject,
                ...content
        }
        notifyvalue=JSON.stringify(notifyvalue);
        if(navigator.sendBeacon){
            const sent = navigator.sendBeacon(
                url,
                notifyvalue,
            );
            if (sent) {
                this.errored = false;
            } else {
                if (!(this.errored)) {
                    this.errored = true;
                    console.debug(
                        'log error, beacon failed',
                        url,
                    );
                }
            }
        } else{
            console.log("There is no beacon support using alternative way using fetch");
            fetch(url,{
                method: 'POST',
                body: notifyvalue,
                cache: 'no-cache',
            });
        }
    }
}
